import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { hideRequestListBox } from "./coeSlice";
import { env } from "../../environment";
import { XIcon } from "@heroicons/react/solid";
export default function COERequestListBox() {
  const requestListBox = useSelector((state) => state.coe.requestListBox);

  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");

  const [success, setSuccess] = useState(false);
  const [emailFailure, setEmailFailure] = useState(false);

  const dispatch = useDispatch();
  // Disable scroll
  if (requestListBox == true) {
    document.body.style.overflow = "hidden";
  }

  function register() {
    // Check
    if (email == confirmEmail && email != "" && validateEmail(email)) {
      let fetchURL =
        env +
        "inmateSubscribe.do?method=requestList&email=" +
        email +
        "&email2=" +
        confirmEmail;
      fetch(fetchURL)
        .then((response) => response.json())
        .then((data) => {
          if (data.type == "success") {
            hideRequestError();
            setSuccess(true);
            dispatch(hideRequestListBox());
          }
        });
    } else if (validateEmail(email) == false && email != "") {
      document.getElementById("requestError").innerHTML =
        "Email must be in a valid format.";
    } else if (email == "") {
      document.getElementById("requestError").innerHTML =
        "Email is required. (255 characters max)";
    } else if (confirmEmail == "") {
      document.getElementById("requestError").innerHTML =
        "Email Re-entry is required. (255 characters max)";
    } else if (email != confirmEmail) {
      document.getElementById("requestError").innerHTML =
        "Email Addresses must match";
    }
  }

  function validateEmail(email) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  }

  function hideRequestError() {
    document.getElementById("requestError").innerHTML = "";
  }

  function exit() {
    dispatch(hideRequestListBox());
    setSuccess(false);
    setEmailFailure(false);
    setEmail("");
    setConfirmEmail("");
    hideRequestError();
    document.body.style.overflow = "auto";
  }
  return (
    <div>
      <div
        onClick={() => exit()}
        className=" z-40 w-full h-full bg-gray-100 opacity-80  fixed "
        style={{
          display: requestListBox || success ? "" : "none",
        }}
      ></div>
      <div
        className=" z-50 m-auto bg-gray-300 fixed opacity-100 top-2/4 left-2/4 p-3 pb-1 sm:border-solid sm:border-black sm:border-4"
        style={{
          transform: "translate(-50%, -50%)",
          width: window.innerWidth < 640 ? "100%" : "500px",
          display: requestListBox || success ? "" : "none",
        }}
      >
        <div
          style={{ display: requestListBox ? "" : "none" }}
          className="shadow-lg"
        >
          <div className="p-2 bg-orange-light border border-black border-4 text-lg">
            Request List of Registrations
          </div>
          <div className="bg-gray-100 p-2">
            <div className="text-red-500" id="requestError"></div>

            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Email Address
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="email"
                  id="email"
                  onChange={(e) => setEmail(e.target.value)}
                  value={email}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700"
              >
                Confirm Email Address
              </label>
              <div className="mt-1">
                <input
                  type="text"
                  name="email"
                  id="email"
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  className="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  placeholder="you@example.com"
                />
              </div>
            </div>
            <div>
              <button
                onClick={() => register()}
                className="p-2 mt-2 bg-blue-dark text-white rounded-md"
              >
                Register
              </button>
              <button
                className="p-2 mt-2 ml-2 bg-red-500 text-white rounded-md"
                onClick={() => {
                  exit();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
        <div style={{ display: success ? "" : "none" }}>
          Your Request for a List of Custodian Of Evidence (COE) Registrations
          pursuant to S.C. Code §17-28-330(A) has been received and should be
          processed shortly. Please check your supplied email address for a
          confirmation link.
        </div>
        <div className="float-right mt-2">
          <button onClick={exit}>
            <XIcon className="w-8" />
          </button>
        </div>
        Copyright © 2021 SCDC
      </div>
    </div>
  );
}
